import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { IProduct } from './product';
import { ProductService } from './products.service';
import { OnlineOrderService } from '../onlineorder/onlineorder.service';
import { IOnlineOrder } from '../onlineorder/onlineorder';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { LoginService } from '../home/login.service';
import { Subscription } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { IRep } from '../home/rep';
import { ICartItems } from '../onlineorder/cartitems';
import { AppComponent } from '../app.component';
import { OrderService } from '../onlineorder/order.service';
import { IProductDetail } from './productdetails';
import { IRepPublicData } from '../home/repPublicData';
import { TranslateService } from '@ngx-translate/core';
import { AdminService } from '../admin/admin.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  standalone: false,
  templateUrl: './product-detail.component.html',
})
export class ProductDetailComponent implements OnInit {
  pageTitle: string = 'Product Details';
  private sub: Subscription;
  private sub2!: Subscription;
  public repId1!: string;
  public prodId!: string;
  public currentUser: any;
  public custName: string = '';

  errorMessage!: string;
  onlineorder!: IOnlineOrder[];
  popUpHtml: string = '<div>Item added to cart' + '</div>';
  public checkResult!: boolean;
  rep!: IRepPublicData;
  detail: IProductDetail[] = [];
  @Input() public count: number = 0;
  @Output() countChange: EventEmitter<number> = new EventEmitter<number>();
  public options = {
    position: ['bottom', 'right'],
    timeOut: 6000,
    lastOnBottom: true,
    preventDuplicates: false,
    preventLastDuplicates: false,
  };
  public caption: string;
  public transErrMsg: string;
  translatedText = '';
  constructor(
    private _route: ActivatedRoute,
    private _router: Router,
    private _productService: ProductService,
    private login: LoginService,
    public _onlineOrderService: OnlineOrderService,
    public app: AppComponent,
    public toaster: ToastrService,
    private orderService: OrderService,
    public translate: TranslateService,
    public admin: AdminService,
    public spinner: NgxSpinnerService
  ) {
    this.sub = this._route.params.subscribe((params) => {
      let id = +params['id:prodId'];
      //console.log(params);
      //console.log(id);
      this._productService
        .getRepInfo(id.toString())
        .subscribe((rep: IRepPublicData) => {
          this.rep = rep;
          this.app.rep = rep;
        });

      this.repId1 = id.toString();
      localStorage.setItem('repId', id.toString());

      this.custName = localStorage.getItem('custName') || '';
      this.app.myCustName = this.custName;

      //this.repIdUniversal.emit(id.toString());
    });
  }
  getLocale(): any {
    var currentLocale = localStorage.getItem('locale');
    return currentLocale;
  }
  googleTranslateCall(textToTrans: string, targetLang: string): string {
    let model = {
      q: [textToTrans],
      target: targetLang,
    };
    this.admin.googleTranslate(model).subscribe((response: any) => {
      //console.log('Translate Call: ' + response.data.translations[0].translatedText);
      this.translatedText = response.data.translations[0].translatedText;
      return this.translatedText;
    });
    return '';
  }
  showError(errorMessage: string, subject: string, staticErrorMsg: boolean) {
    //use this for dynamic error messages
    if (staticErrorMsg === false) {
      let locale = this.getLocale();
      if (locale !== 'en') {
        //were gonna do it nested, couldn't do it as a standalone method.
        let model = {
          q: [errorMessage],
          target: locale,
        };

        this.admin.googleTranslate(model).subscribe(
          (response: any) => {
            let res = response.data.translations[0].translatedText as string;
            this.translatedText = response.data.translations[0]
              .translatedText as string;
            this.transErrMsg = this.translatedText;
            localStorage.setItem('translatedText', res);
          },
          (error) => console.log(error),
          () => {
            this.translate.get(subject).subscribe(
              (res: string) => {
                this.caption = res;
                console.log(res);
              },
              (error) => console.log(error),
              () => {
                this.spinner.hide();
                //once the caption is translated, fire off the toaster popup
                this.toaster.error(this.transErrMsg, this.caption, {
                  timeOut: 5000,
                });
                localStorage.removeItem('translatedText');
              }
            );
          }
        );

        //this.transErrMsg =  this.translatedText;
      } else {
        this.translate.get(subject).subscribe(
          (res: string) => {
            this.caption = res;
            console.log(res);
          },
          (error) => console.log(error),
          () => {
            this.transErrMsg = errorMessage;
            this.spinner.hide();
            //once the caption is translated, fire off the toaster popup
            this.toaster.error(this.transErrMsg, this.caption, {
              timeOut: 5000,
            });
            localStorage.removeItem('translatedText');
          }
        );
      }
    } else {
      // translate the error message - not dynamic
      this.translate.get(errorMessage).subscribe((res: string) => {
        this.transErrMsg = res;
        console.log(res);
      });

      // translate the caption
      this.translate.get(subject).subscribe((res: string) => {
        this.caption = res;
        console.log(res);
      });
      this.spinner.hide();
      //show the toaster popup
      this.toaster.error(this.transErrMsg, this.caption, {
        timeOut: 5000,
      });
    }
  }

  addToCartPopup(message: string): void {
    this.translate.get(message).subscribe((res: string) => {
      this.transErrMsg = res;
      console.log(res);
    });

    // // translate the caption
    // this.translate.get(subject).subscribe((res: string) => {
    //     this.caption = res;
    //     console.log(res);
    // });
    this.spinner.hide();
    //show the toaster popup
    this.toaster.show('<div>' + this.transErrMsg + '</div>', '', {
      timeOut: 3000,
      enableHtml: true,
    });
  }
  addProduct(sku: string, desc: string, price: number, url: string): void {
    var currentUser1 = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );
    this.login.token = currentUser1 && currentUser1.access_token;
    var newCount = localStorage.getItem('prodCount');

    if (Number(newCount) < 1) {
      if (this.login.loggedIn()) {
        let item1: ICartItems = {
          ProductId: sku,
          DisplayName: desc,
          ImageUrl: url,
          Price: price,
          Quantity: 1,
        };

        this._onlineOrderService.checkIfOrdered2(sku).subscribe(
          (thing) => console.log(thing),
          (error: any) => {
            // if (this.checkResult == false) {
            if (this._onlineOrderService.addItem(item1) == true) {
              this.count++;
              this.countChange.emit(this.count);
              this.app.myProdCount = this.count;
              localStorage.setItem(
                'cartItems',
                JSON.stringify(this._onlineOrderService.getCart())
              );
              localStorage.setItem('prodCount', this.count.toString());
              this._onlineOrderService.addToOrder(sku).subscribe(
                (thing: IOnlineOrder[]) => (this.onlineorder = thing),
                (error: string) => (this.errorMessage = error),
                () => {
                  this._onlineOrderService
                    .updateShipMethodPlusTotals2()
                    .subscribe();
                }
              );
              this.addToCartPopup('products.toastPopups.addToCart');
            }
            // }
            // else {
            //     this._onlineOrderService.addItemAlreadyOrderedError();
            // }
          },
          () =>
            this.showError(
              'products.toastPopups.errors.alreadyOrdered',
              'products.toastPopups.errors.titles.title1',
              true
            )
        );
      } else {
        let item1: ICartItems = {
          ProductId: sku,
          DisplayName: desc,
          ImageUrl: url,
          Price: price,
          Quantity: 1,
        };
        if (this._onlineOrderService.addItem(item1) == true) {
          this.count++;
          this.countChange.emit(this.count);

          //localStorage.removeItem('authorizationData');
          this.app.myProdCount = this.count;
          localStorage.setItem(
            'cartItems',
            JSON.stringify(this._onlineOrderService.getCart())
          );
          localStorage.setItem('prodCount', this.app.myProdCount.toString());
          this.addToCartPopup('products.toastPopups.addToCart');
        }
      }
    } else {
      this.showError(
        'products.toastPopups.errors.oneOfEach',
        'products.toastPopups.errors.titles.title1',
        true
      );
    }
  }

  addProduct2(sku: string, desc: string, price: number, url: string): void {
    var currentUser1 = JSON.parse(
      localStorage.getItem('authorizationData') || '{}'
    );
    this.login.token = currentUser1 && currentUser1.access_token;
    var newCount = localStorage.getItem('prodCount');

    if (Number(newCount) < 1) {
      if (this.login.loggedIn()) {
        let item1: ICartItems = {
          ProductId: sku,
          DisplayName: desc,
          ImageUrl: url,
          Price: price,
          Quantity: 1,
        };

        this.orderService.checkIfOrdered2(sku).subscribe(
          (thing) => console.log(thing),
          (error: any) => {
            // if (this.checkResult == false) {
            if (this.orderService.addItem(item1) == true) {
              this.count++;
              this.countChange.emit(this.count);
              this.app.myProdCount = this.count;
              localStorage.setItem(
                'cartItems',
                JSON.stringify(this.orderService.getCart())
              );
              localStorage.setItem('prodCount', this.count.toString());
              this.orderService.addToOrder(sku).subscribe(
                (thing: IOnlineOrder[]) => (this.onlineorder = thing),
                (error: string) => (this.errorMessage = error),
                () => {
                  this.orderService.updateShipMethodPlusTotals2().subscribe();
                }
              );
              this.addToCartPopup('products.toastPopups.addToCart');
            }
            // }
            // else {
            //     this._onlineOrderService.addItemAlreadyOrderedError();
            // }
          },
          () =>
            this.showError(
              'products.toastPopups.errors.alreadyOrdered',
              'products.toastPopups.errors.titles.title1',
              true
            )
        );
      } else {
        let item1: ICartItems = {
          ProductId: sku,
          DisplayName: desc,
          ImageUrl: url,
          Price: price,
          Quantity: 1,
        };
        if (this.orderService.addItem(item1) == true) {
          this.count++;
          this.countChange.emit(this.count);

          //localStorage.removeItem('authorizationData');
          this.app.myProdCount = this.count;
          localStorage.setItem(
            'cartItems',
            JSON.stringify(this.orderService.getCart())
          );
          localStorage.setItem('prodCount', this.app.myProdCount.toString());
          this.addToCartPopup('products.toastPopups.addToCart');
        }
      }
    } else {
      this.showError(
        'products.toastPopups.errors.onePerOrder',
        'products.toastPopups.errors.titles.title1',
        true
      );
    }
  }
  repId(): any {
    var currentId = localStorage.getItem('repId');
    return currentId;
  }
  ngOnInit(): void {
    var myCart = JSON.parse(localStorage.getItem('cartItems') || '{}');
    if (myCart !== null) {
      // this._onlineOrderService.cart = myCart;
      this.orderService.cart = myCart;
    }

    var newCount = localStorage.getItem('prodCount');
    if (Number(newCount) > 0) {
      this.count = Number(newCount);
    }
    //enable for prod
    // if (this._onlineOrderService.getCart().length > 0) {
    //     this.app.myProdCount = this.count;
    // }
    // else {
    //     this.count = 0;
    //     this.app.myProdCount = this.count;
    //     localStorage.removeItem('prodCount');
    // }

    if (this.orderService.getCart().length > 0) {
      this.app.myProdCount = this.count;
    } else {
      this.count = 0;
      this.app.myProdCount = this.count;
      localStorage.removeItem('prodCount');
    }
    this.repId1 = this.repId();
    this.app.myRepID = Number(this.repId1);

    // add auth check here
    if (this.login.loggedIn()) {
      // this.login.refreshToken();
      this._productService
        .getRepInfo(this.repId1)
        .subscribe((rep: IRepPublicData) => (this.rep = rep));
      this.custName = localStorage.getItem('custName') || '';
      this.rep = this.app.rep;
      this.app.myCustName = this.custName;
      this.login.custName = this.custName;
    } else {
      this._productService
        .getRepInfo(this.repId1)
        .subscribe((rep: IRepPublicData) => (this.rep = rep));
    }

    //this.repId = location.pathname.split("/")[3];
    //localStorage.setItem('repId', this.repId.toString());

    this.sub2 = this._route.queryParams.subscribe((params) => {
      // Defaults to 0 if no query param provided.
      let id = params['prodId'];
      this.prodId = id;
      //console.log(id);
    });
    this._productService
      .getProductDetails2(this.prodId)
      .subscribe((detail: IProductDetail[]) => (this.detail = detail));
    //console.log(this.details.length);
  }
}
